<neo-formulario-filtros-tabla #formularioFiltros
    [valoresIniciales]="valoresInicialesFiltros"
    (cambiosFormulario)="cambiosFormulario($event)"
>
<ng-content></ng-content>
</neo-formulario-filtros-tabla>